import { useTranslation } from "next-i18next";
import Image from "next/image";
import Marquee from "react-fast-marquee";
import marqueeConfigs from "./markquee";

interface Props {
	locale: string;
	participateCount: number;
	onDownloadRockFlow: () => void;
}
export default function MarqueeView(props: Props) {
	const { t } = useTranslation("activities");

	const getMarqueeRow = () => {
		const dataS = marqueeConfigs[props.locale] || marqueeConfigs["en"];
		// 随机打乱

		return dataS.sort(() => Math.random() - 0.5);
	};

	return (
		<div className="mt-5">
			<p className="px-4 text-left">{t("xxxx-participants", { num: `${props.participateCount}+` })}</p>
			<div className="mt-4 w-full overflow-x-hidden">
				<Marquee gradient={false} speed={16}>
					{getMarqueeRow().map((item, index) => (
						<span
							key={index}
							className="m-2 inline-block rounded-3xl border-[1px] border-[#7E60AB]  px-2 py-1 text-xs text-[#BC96F4]"
						>
							{item}
						</span>
					))}
				</Marquee>

				<Marquee gradient={false} speed={16} delay={1}>
					{getMarqueeRow().map((item, index) => (
						<span
							key={index}
							className="m-2 inline-block rounded-3xl border-[1px] border-[#7E60AB]  px-2 py-1 text-xs text-[#BC96F4]"
						>
							{item}
						</span>
					))}
				</Marquee>
			</div>

			<a
				className="mt-4 flex w-full items-center py-2 pl-5"
				style={{
					background: "linear-gradient(90.48deg, #BF6FFF 0%, #5A5EF0 65.63%, #000000 135.45%)",
				}}
				id="downloadRockFlow"
				onClick={props.onDownloadRockFlow}
			>
				<Image
					src="https://web-cdn.rockflow.tech/h5/activities/stock-rebate/invite/double-icon.png"
					width={10}
					height={13}
					alt=""
					className="flex-shrink-0"
					style={{
						maxWidth: "100%",
						height: "auto",
					}}
				/>
				<span className="ml-2 flex-1 text-[15px] font-bold tracking-[0.2px] text-white">
					{t("downloadRockFlow", { ns: "common" })}
				</span>
			</a>
		</div>
	);
}
